const environment = {
  apiUrl: '',
  name: 'dev',
  company: 'Evolutio DEV',
  production: false,
  hostname: '2iqvu9qwl7.execute-api.eu-central-1.amazonaws.com/dev',
  apiPort: '',
  webSocketPort: '8080',
  globalPrefix: 'api',
  apiVersion: 'v1',
  httpsEnabled: true,
  apiAuthUrl: '',
  apiUsersUrl: '',
  apiAdminUrl: '',
  apiAnalyticsUrl: '',
  apiCategories: '',
  apiAudiosUrl: '',
  GENESYS_CLOUD_CLIENT_ID: '',
  REDIRECT_URI: '',
  staticAssetsUrl: '', // autogenerated
  publicFileUrl: '',
  serverSocketUrl: '', // autogenerated
  apiGatewayUrl: '',
};

environment.apiUrl =
  (window['env'] && window['env']['gatewayUrl']) ||
  `${environment.httpsEnabled ? 'https://' : 'http://'}${`${environment.hostname}${environment.apiPort ? `:${environment.apiPort}` : ''}`}`;
environment.apiAuthUrl =
  (window['env'] && window['env']['apiAuthUrl']) ||
  `${environment.httpsEnabled ? 'https://' : 'http://'}${`${environment.hostname}${environment.apiPort ? `:${environment.apiPort}` : ''}/auth`}`;
environment.apiUsersUrl =
  (window['env'] && window['env']['apiUserUrl']) ||
  `${environment.httpsEnabled ? 'https://' : 'http://'}${`${environment.hostname}${environment.apiPort ? `:${environment.apiPort}` : ''}/user`}`;
environment.apiAdminUrl =
  (window['env'] && window['env']['apiAdminUrl']) ||
  `${environment.httpsEnabled ? 'https://' : 'http://'}${`${environment.hostname}${environment.apiPort ? `:${environment.apiPort}` : ''}/admin`}`;
environment.apiAnalyticsUrl =
  (window['env'] && window['env']['apiAnalyticsUrl']) ||
  `${environment.httpsEnabled ? 'https://' : 'http://'}${`${environment.hostname}${environment.apiPort ? `:${environment.apiPort}` : ''}/analytics`}`;
environment.apiCategories =
  (window['env'] && window['env']['apiCategoriesUrl']) ||
  `${environment.httpsEnabled ? 'https://' : 'http://'}${`${environment.hostname}${environment.apiPort ? `:${environment.apiPort}` : ''}/categories`}`;
environment.apiAudiosUrl =
  (window['env'] && window['env']['apiAudiosUrl']) ||
  `${environment.httpsEnabled ? 'https://' : 'http://'}${`${environment.hostname}${environment.apiPort ? `:${environment.apiPort}` : ''}/audios`}`;
environment.staticAssetsUrl = `${environment.httpsEnabled ? 'https://' : 'http://'}${environment.hostname}${environment.apiPort ? `:${environment.apiPort}` : ''}`;
environment.serverSocketUrl = `${environment.httpsEnabled ? 'wss://' : 'ws://'}${environment.hostname}:${environment.webSocketPort}`;
environment.publicFileUrl = `${environment.httpsEnabled ? 'https://' : 'http://'}${`${environment.hostname}${environment.apiPort ? `:${environment.apiPort}` : ''}`}/file-uploader-folder`;
environment.GENESYS_CLOUD_CLIENT_ID =
  (window['env'] && window['env']['GENESYS_CLOUD_CLIENT_ID']) || ``;
environment.REDIRECT_URI =
  (window['env'] && window['env']['REDIRECT_URI']) || ``;

export default environment;
